import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import QuizLandingView from '../views/QuizLandingView.vue'
import QuizTestingView from '../views/QuizTestingView.vue'
import QuizBufferingView from '../views/QuizBufferingView.vue'
import QuizResultView from '../views/QuizResultView.vue'
import StaticView from '../views/StaticView.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: HomeView },
  { path: '/quiz/:id', name: 'QuizLanding', component: QuizLandingView, props: true },
  { path: '/quiz/:id/test', name: 'QuizTest', component: QuizTestingView, props: true },
  { path: '/quiz/:id/buffering', name: 'QuizBuffering', component: QuizBufferingView, props: true },
  { path: '/quiz/:id/result', name: 'QuizResult', component: QuizResultView, props: true },
  { path: '/about', name: 'About', component: StaticView, props: { type: 'about' } },
  { path: '/privacy', name: 'Privacy', component: StaticView, props: { type: 'privacy' } },
  { path: '/terms', name: 'Terms', component: StaticView, props: { type: 'terms' } },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes
})

export function isNavigationDuplicated (error) {
  if (!error) return false
  if (error.name === 'NavigationDuplicated') return true
  const message = error.message || String(error)
  return message.includes('Avoided redundant navigation')
}

function silenceDuplicated (promise) {
  return promise.catch(err => {
    if (isNavigationDuplicated(err)) return
    throw err
  })
}

const originalPush = router.push.bind(router)
const originalReplace = router.replace.bind(router)

router.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush(location, onResolve, onReject)
  }
  return silenceDuplicated(originalPush(location))
}

router.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace(location, onResolve, onReject)
  }
  return silenceDuplicated(originalReplace(location))
}

export default router
